import React from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "../../css/home/banner.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Banner({ onSlideClick }) {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: true,
        arrows: true
    };

    const slides = [
        {
            imgSrc: "assets/home/stations/basic.png",
            title: "Basic Model",
            subtitle: "Pratik Şarj İstasyonları",
            textUp: "Hızlı tak Çalıştır Özelliği İle",
            textDown: "Kullanıcı Dostu ve Ekonomik Çözümler",
            modelType: "Basic"
        },
        {
            imgSrc: "assets/home/stations/smart.png",
            title: "Smart Model",
            subtitle: "Akıllı Şarj İstasyonları",
            textUp: "Uzaktan Erişim ve Kontrol",
            textDown: "Mobil Uygulama Desteği",
            modelType: "Smart"
        },
        {
            imgSrc: "assets/home/stations/premium.png",
            title: "Premium Model",
            subtitle: "Premium Şarj İstasyonları",
            textUp: "Kalite ve Güvenlik Protokolleriyle",
            textDown: "Kurumsal-Profesyonel Çözümler",
            modelType: "Premium"
        },
        {
            imgSrc: "assets/home/stations/dual.png",
            title: "Dual Model",
            subtitle: "Dual Şarj İstasyonları",
            textUp: "Yüksek güç ve 2X verimlilik ile",
            textDown: "Teknoloji ve Tasarımın Buluşması",
            modelType: "Dual"
        }
    ];
    const navigate = useNavigate(); // useNavigate hook'unu ekleyelim

    const handleSlideClick = (modelType) => {
        const params = new URLSearchParams();
        params.set('category', 'AC İstasyonlar');
        params.set('model', modelType);

        navigate({
            pathname: '/products',
            search: params.toString()
        });
    };

    return (
        <div className="Banner">
            <Slider {...settings}>
                {slides.map((slide, index) => (
                    <div key={index} onClick={() => handleSlideClick(slide.modelType)} style={{ cursor: 'pointer' }}>
                        <div className="BannerRow">
                            <div>
                                <img src={slide.imgSrc} width="" height="300" alt="Station" />
                            </div>
                            <div>
                                <h1 className="BannerText">{slide.title}</h1>
                                <h3 className="BannerText">{slide.subtitle}</h3>
                                <h4 className="BannerText">{slide.textUp}</h4>
                                <h4 className="BannerText">{slide.textDown}</h4>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default Banner;